var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6133 8.94667C19.0933 8.42667 18.2533 8.42667 17.7333 8.94667L11.6133 15.0667C11.0933 15.5867 11.0933 16.4267 11.6133 16.9467L17.7333 23.0667C18.2533 23.5867 19.0933 23.5867 19.6133 23.0667C20.1333 22.5467 20.1333 21.7067 19.6133 21.1867L14.44 16L19.6133 10.8267C20.1333 10.3067 20.12 9.45334 19.6133 8.94667Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjYxMzMgOC45NDY2N0MxOS4wOTMzIDguNDI2NjcgMTguMjUzMyA4LjQyNjY3IDE3LjczMzMgOC45NDY2N0wxMS42MTMzIDE1LjA2NjdDMTEuMDkzMyAxNS41ODY3IDExLjA5MzMgMTYuNDI2NyAxMS42MTMzIDE2Ljk0NjdMMTcuNzMzMyAyMy4wNjY3QzE4LjI1MzMgMjMuNTg2NyAxOS4wOTMzIDIzLjU4NjcgMTkuNjEzMyAyMy4wNjY3QzIwLjEzMzMgMjIuNTQ2NyAyMC4xMzMzIDIxLjcwNjcgMTkuNjEzMyAyMS4xODY3TDE0LjQ0IDE2TDE5LjYxMzMgMTAuODI2N0MyMC4xMzMzIDEwLjMwNjcgMjAuMTIgOS40NTMzNCAxOS42MTMzIDguOTQ2NjdaIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };